export function formatItemLabel(key: string, name: string): string {
  switch (key) {
    case 'exterior':
      return `${name} Exterior`;
    case 'interior':
      return `${name} Interior`;
    default:
      return name;
  }
}
